import React from 'react';
import { useTranslation } from 'react-i18next';

const COLORS = {
  DRAFT:               { bg: '#f3f4f6', fg: '#374151', border: '#d1d5db' },
  DECLARED:            { bg: '#dbeafe', fg: '#1e40af', border: '#93c5fd' },
  UNDER_INVESTIGATION: { bg: '#fef3c7', fg: '#92400e', border: '#fcd34d' },
  CLOSED:              { bg: '#dcfce7', fg: '#166534', border: '#86efac' },
};

const KEYS = {
  DRAFT: 'compliance.materiovigilance.status.draft',
  DECLARED: 'compliance.materiovigilance.status.declared',
  UNDER_INVESTIGATION: 'compliance.materiovigilance.status.under_investigation',
  CLOSED: 'compliance.materiovigilance.status.closed',
};

const MaterioStatusBadge = ({ status }) => {
  const { t } = useTranslation();
  if (!status) return null;
  const c = COLORS[status] || COLORS.DRAFT;
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
        background: c.bg,
        color: c.fg,
        border: `1px solid ${c.border}`,
        whiteSpace: 'nowrap',
      }}
    >
      {t(KEYS[status] || status, status.replace('_', ' '))}
    </span>
  );
};

export default MaterioStatusBadge;
